"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysInWeek = void 0;
const locale_1 = require("date-fns/locale");
const daysInWeek = ({ locale = locale_1.id }) => [
    { day: 0, label: locale.localize?.day(0) },
    { day: 1, label: locale.localize?.day(1) },
    { day: 2, label: locale.localize?.day(2) },
    { day: 3, label: locale.localize?.day(3) },
    { day: 4, label: locale.localize?.day(4) },
    { day: 5, label: locale.localize?.day(5) },
    { day: 6, label: locale.localize?.day(6) },
];
exports.daysInWeek = daysInWeek;
